<template>
  <div class="player-container">
    <div class="current-player">{{ currentPlayer }}</div>
    <div class="player-header">Players</div>
    <table>
      <tr v-for="player in players" v-bind:key="player.uuid">
        <td class="player-name">{{ player.name }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
const PLAYER_NOT_THERE = '―'

export default {
  name: 'PlayerList',
  props: {
    players: Array,
    currentPlayerUuid: String
  },
  computed: {
    currentPlayer () {
      for (const player of this.players) {
        if (player.uuid === this.currentPlayerUuid) {
          return player.name
        }
      }
      return PLAYER_NOT_THERE
    }
  }
}
</script>

<style scoped>
.player-container {
  min-width: 160px;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: var(--box-shadow);
  background: var(--surface-color);
}

.player-name {
  font-size: 1rem;
  padding: .25rem 0;
}

.player-header {
  color: var(--muted-color);
  margin-bottom: 0.3rem;
  font-size: 0.95rem;
}

.current-player {
  margin: 0.5rem 0 0.75rem 0;
  font-size: 1.05rem;
  text-align: center;
  font-weight: 700;
  color: var(--accent-strong);
}

</style>
